import React, { useEffect, useState } from 'react';
import { Field } from 'react-final-form';
import IconPlus from '../../../containers/SearchPage/IconPlus/IconPlus';
import css from './ProfileSettingsForm.module.css';
import { ImageFromFile } from '../../../components';
import { FormattedMessage } from 'react-intl';
import { postGetFileFromS3 } from '../../../util/api';
import { Buffer } from 'buffer';
import Spinner from '../../../components/IconSpinner/IconSpinner';
import { PASSPORT_UPLOAD_ACCEPT, validatePassportUploadFile } from '../../../util/passportUpload';
const FileUploader = props => {
  const { form, formId, initialValues = {}, isModalUpload } = props;

  const uploadedFileIdOrPassportIntialValues = initialValues.idorpassport
    ? props.initialValues.idorpassport
    : null;

  const [uploadFileIdOrPassport, setUploadFileIdOrPassport] = useState();
  const [loading, setLoading] = useState(false);
  const [uploadErrorId, setUploadErrorId] = useState(null);

  const onUploadPassport = async () => {
    if (uploadedFileIdOrPassportIntialValues) {
      setLoading(true);
      try {
        const data = await postGetFileFromS3({ Key: uploadedFileIdOrPassportIntialValues });
        let buf = Buffer.from(data.Body);
        const blob = new Blob([buf]);
        const url = blob;
        setUploadFileIdOrPassport(url);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    onUploadPassport();
  }, [uploadedFileIdOrPassportIntialValues]);

  const imageFromFileIdOrPassport = uploadFileIdOrPassport ? (
    <ImageFromFile
      id={uploadedFileIdOrPassportIntialValues}
      rootClassName={css.imageFromFile}
      aspectWidth={1}
      aspectHeight={1}
      file={uploadFileIdOrPassport}
    />
  ) : null;

  const UploadFieldInput = (imageFromFile, changeLabel, chooseLabel) => {
    return imageFromFile ? (
      <div className={css.imageFromFileWrapper}>
        <div
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            const url = window.URL.createObjectURL(uploadFileIdOrPassport);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = url;
            a.download = uploadedFileIdOrPassportIntialValues;
            a.click();
            window.URL.revokeObjectURL(url);
          }}
        >
          {imageFromFile}
        </div>
        <div className={css.imageFromFileLabelWrapper}>
          <span className={css.imageFromFileLabel}>
            <FormattedMessage id={changeLabel} />
          </span>
        </div>
      </div>
    ) : (
      <div className={css.uploadZone}>
        <span className={css.uploadZoneLabel}>
          <FormattedMessage id={chooseLabel} />
        </span>
        <span className={css.uploadZoneIconWrapper}>
          <IconPlus className={css.uploadZoneIcon} isOpen={false} />
        </span>
      </div>
    );
  };

  const chooseLogo2Label = UploadFieldInput(
    imageFromFileIdOrPassport,
    'EditListingDetailsForm.changeIdOrPassportLabel',
    'EditListingDetailsForm.chooseIdOrPassportLabel'
  );

  const uploadErrorMaybe = uploadErrorId ? (
    <p className={css.error}>
      <FormattedMessage id={uploadErrorId} />
    </p>
  ) : null;

  return (
    <Field
      accept={PASSPORT_UPLOAD_ACCEPT}
      id={`${formId}.idorpassport`}
      name="idorpassport"
      label={chooseLogo2Label}
      type="file"
      form={null}
    >
      {fieldProps => {
        const { accept, id, input, label, disabled } = fieldProps;
        const { name, type } = input;
        const onChange = e => {
          const file = e.target.files[0];
          if (file) {
            const validation = validatePassportUploadFile(file);

            if (!validation.isValid) {
              form.change(`idorpassport`, null);
              form.blur(`idorpassport`);
              setUploadErrorId(validation.errorId);
              e.target.value = '';
              return;
            }

            form.change(`idorpassport`, file);
            form.blur(`idorpassport`);
            setUploadFileIdOrPassport(file);
            setUploadErrorId(null);
          }
        };

        let error = null;

        return !initialValues.isVerified ? (
          <div className={css.uploadWrapper}>
            {isModalUpload ? (
              <p className={css.infoText}>
                <FormattedMessage id="UploadPassportModal.info" />
              </p>
            ) : (
              <>
                <label>
                  <FormattedMessage id="EditListingDetailsForm.documentationLabel" />
                </label>
                <p className={css.fieldText}>
                  <FormattedMessage id="EditListingDetailsForm.documentationDesciption" />
                </p>
              </>
            )}
            <label className={css.uploadLabel} htmlFor={id}>
              {loading ? <Spinner /> : label}
            </label>
            <input
              accept={accept}
              id={id}
              name={name}
              className={css.uploadInput}
              disabled={disabled || loading}
              onChange={onChange}
              type={type}
            />
            {uploadedFileIdOrPassportIntialValues || initialValues.passportUploaded ? (
              <p>
                Your passport has been submitted. Our Head of KYC will now review it and you will be
                notified once your passport has been verified. This can take up to 24 hours. In line
                with GDPR your passport will be automatically deleted 10 days after submission
              </p>
            ) : null}
            {uploadErrorMaybe}
            {error}
          </div>
        ) : (
          <div className={css.uploadWrapper}>
            <p>
              Your passport has been verified. In line with GDPR your passport will be automatically
              deleted 10 days after submission
            </p>
          </div>
        );
      }}
    </Field>
  );
};

export default FileUploader;
